/** Browser notification when a video is ready (only if the person asked for it, and only when the tab is hidden). */
export function notifyReady(what: string, title: string) {
  try {
    if (typeof Notification !== 'undefined' && Notification.permission === 'granted' && document.hidden) new Notification(what, { body: title, icon: '/favicon.ico' });
  } catch { /* not available here */ }
}
